import { Component, OnInit, OnDestroy, EventEmitter, Output } from "@angular/core";
import { UpdateService } from "./update.service";
import { SITE_VERSION } from '../../entities/Constants';

@Component({
    selector: 'update',
    templateUrl: './update.component.html',
    styleUrls: ['./update.component.scss']
})
export class UpdateComponent implements OnInit, OnDestroy {
    updateCheckDone: boolean | undefined = null;
    updateInProgress: boolean = false;
    private checkInUpdateDoneSub: any;
    private updateInProgressSub: any;

    version: string;
     
    @Output() destroy = new EventEmitter<boolean>();

    constructor(private updateService: UpdateService) { }

    ngOnInit() {
        //console.log("this.updateService.noServiceWorker", this.updateService.noServiceWorker);
        if (this.updateService.noServiceWorker == true) {

            //if ('serviceWorker' in navigator) {
            //    navigator.serviceWorker.getRegistrations().then(function (registrations) {
            //        //returns installed service workers
            //        if (registrations.length) {
            //            for (let registration of registrations) {
            //                registration.unregister();
            //            }
            //        }
            //    });
            //}

            // si pas service worker, on n'affiche pas le loader
            this.destroy.emit(true);
        }
        else {
            this.updateInProgressSub = this.updateService.updateInProgress.subscribe((data: boolean) => {
                this.updateInProgress = data;
                //console.log("updateInProgressSub", this.updateInProgress);
                if (this.updateInProgressSub != null) this.updateInProgressSub.unsubscribe();
            });

            this.checkInUpdateDoneSub = this.updateService.checkDone.subscribe((data: boolean) => {
                this.updateCheckDone = true;
                //console.log("updateCheckDone", this.updateCheckDone);

                this.destroy.emit(true);
                if (this.updateInProgressSub != null) this.updateInProgressSub.unsubscribe();
                if (this.checkInUpdateDoneSub != null) this.checkInUpdateDoneSub.unsubscribe();
            });
        }

        this.version = SITE_VERSION;
        //console.log(this.version);

    }

    ngOnDestroy(): void {
        if (this.updateInProgressSub != null) this.updateInProgressSub.unsubscribe();
        if (this.checkInUpdateDoneSub != null) this.checkInUpdateDoneSub.unsubscribe();
    }
}
